import React, { createContext, useMemo, useState } from "react";

export const MergeFilesDataContext = createContext({});

export function MergeFilesDataProvider({ children }) {
  const [page, setPage] = useState(1);
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState(false);
  const [awaitingResponse, setAwaitingResponse] = useState(false);
  const [postResponse, setPostResponse] = useState({});
  const [validFile, setValidFile] = useState(false);

  const props = useMemo(
    () => ({
      page,
      setPage,
      open,
      setOpen,
      message,
      setMessage,
      awaitingResponse,
      setAwaitingResponse,
      postResponse,
      setPostResponse,
      validFile,
      setValidFile,
    }),
    [page, open, message, awaitingResponse, postResponse, validFile]
  );

  return (
    <MergeFilesDataContext.Provider value={props}>
      {children}
    </MergeFilesDataContext.Provider>
  );
}
